// Composants statistiques partagés (admin + espace commerçant).
export function dayPlus(offset) {
  const d = new Date();
  d.setDate(d.getDate() + offset);
  return d.toISOString().slice(0, 10);
}

export function PeriodPicker({ from, to, onChange }) {
  const presets = [
    { label: "7 derniers jours", f: dayPlus(-6), t: dayPlus(0) },
    { label: "30 derniers jours", f: dayPlus(-29), t: dayPlus(0) },
  ];
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="period-picker">
      {presets.map((p) => (
        <button
          key={p.label}
          onClick={() => onChange(p.f, p.t)}
          className={`rounded-full px-4 py-2 font-display text-xs font-semibold transition-colors ${
            from === p.f && to === p.t
              ? "bg-nuit-900 text-white"
              : "border border-nuit-900/15 bg-white text-nuit-900 hover:border-nuit-900/40"
          }`}
        >
          {p.label}
        </button>
      ))}
      <span className="text-xs text-steel">ou</span>
      <input type="date" value={from} max={to} onChange={(e) => onChange(e.target.value, to)}
        className="rounded-full border border-nuit-900/15 bg-white px-3 py-2 text-xs text-nuit-900" aria-label="Date de début" data-testid="period-from" />
      <span className="text-xs text-steel">→</span>
      <input type="date" value={to} min={from} onChange={(e) => onChange(from, e.target.value)}
        className="rounded-full border border-nuit-900/15 bg-white px-3 py-2 text-xs text-nuit-900" aria-label="Date de fin" data-testid="period-to" />
    </div>
  );
}

export function Bars({ series }) {
  const max = Math.max(1, ...series.map((s) => Math.max(s.views, s.clicks)));
  if (!series.length)
    return <p className="rounded-2xl bg-brume p-6 text-center text-sm text-steel">Aucune donnée sur cette période.</p>;
  return (
    <div>
      <div className="flex h-44 items-end gap-1.5" role="img" aria-label="Évolution des consultations et clics par jour">
        {series.map((s) => (
          <div key={s.day} className="group relative flex flex-1 items-end justify-center gap-0.5">
            <div className="w-full max-w-3 rounded-t bg-nuit-900/80 transition-all" style={{ height: `${(s.views / max) * 100}%` }} />
            <div className="w-full max-w-3 rounded-t bg-electric transition-all" style={{ height: `${(s.clicks / max) * 100}%` }} />
            <span className="pointer-events-none absolute -top-9 hidden whitespace-nowrap rounded-lg bg-nuit-900 px-2 py-1 text-[10px] font-medium text-white group-hover:block">
              {s.day.slice(5)} · {s.views} vues · {s.clicks} clics
            </span>
          </div>
        ))}
      </div>
      <div className="mt-3 flex items-center gap-5 text-xs text-steel">
        <span className="flex items-center gap-1.5"><span className="h-2.5 w-2.5 rounded-sm bg-nuit-900/80" /> Consultations</span>
        <span className="flex items-center gap-1.5"><span className="h-2.5 w-2.5 rounded-sm bg-electric" /> Clics</span>
      </div>
    </div>
  );
}

export function StatCard({ label, value, sub }) {
  return (
    <div className="rounded-2xl border border-nuit-900/10 bg-white p-5">
      <p className="text-xs font-semibold uppercase tracking-wider text-steel">{label}</p>
      <p className="mt-1.5 font-display text-3xl font-bold text-nuit-900">{value}</p>
      {sub && <p className="mt-1 text-xs text-steel">{sub}</p>}
    </div>
  );
}
